import { render } from "./Traits.vue?vue&type=template&id=31ff615e&scoped=true&ts=true"
import script from "./Traits.vue?vue&type=script&lang=ts"
export * from "./Traits.vue?vue&type=script&lang=ts"

import "./Traits.vue?vue&type=style&index=0&id=31ff615e&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ff615e"]])

export default __exports__